// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file user/user.proto (package user, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { AccountMessageSchema } from "../common/billing_pb";
import { file_common_billing } from "../common/billing_pb";
import type { Pagination } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { KycStatus, OnboardingStatus, SessionMessage, TimeFormat, UserMessageSchema, UserSettingMessage, UserSettingMessageSchema } from "../common/user_pb";
import { file_common_user } from "../common/user_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/user.proto.
 */
export const file_user_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_common_billing, file_common_common, file_common_user, file_google_protobuf_empty, file_google_protobuf_struct]);

/**
 * @generated from message user.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<"user.UpdateProfileRequest"> & {
  /**
   * @generated from field: optional string first_name = 1;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string date_of_birth = 3;
   */
  dateOfBirth?: string;

  /**
   * @generated from field: optional string country_code = 4;
   */
  countryCode?: string;

  /**
   * @generated from field: optional string timezone = 5;
   */
  timezone?: string;

  /**
   * @generated from field: optional string language = 6;
   */
  language?: string;

  /**
   * @generated from field: optional bool subscribe_for_news = 7;
   */
  subscribeForNews?: boolean;

  /**
   * @generated from field: optional bool subscribe_for_withdrawals = 8;
   */
  subscribeForWithdrawals?: boolean;

  /**
   * @generated from field: optional bool subscribe_for_deposits = 9;
   */
  subscribeForDeposits?: boolean;

  /**
   * @generated from field: optional bool halal_enabled = 10;
   */
  halalEnabled?: boolean;

  /**
   * @generated from field: optional string date_format = 11;
   */
  dateFormat?: string;

  /**
   * @generated from field: optional common.TimeFormat time_format = 12;
   */
  timeFormat?: TimeFormat;

  /**
   * @generated from field: optional string phone = 13;
   */
  phone?: string;

  /**
   * @generated from field: optional string nickname = 14;
   */
  nickname?: string;

  /**
   * @generated from field: optional bool totp_on_login = 15;
   */
  totpOnLogin?: boolean;

  /**
   * @generated from field: optional bool totp_on_withdraw = 16;
   */
  totpOnWithdraw?: boolean;

  /**
   * @generated from field: optional bool subscribe_for_security = 17;
   */
  subscribeForSecurity?: boolean;

  /**
   * @generated from field: optional bool subscribe_for_common = 18;
   */
  subscribeForCommon?: boolean;

  /**
   * @generated from field: optional bool subscribe_for_stats = 19;
   */
  subscribeForStats?: boolean;

  /**
   * @generated from field: optional bool stream_mode = 20;
   */
  streamMode?: boolean;
};

/**
 * Describes the message user.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 0);

/**
 * @generated from message user.ListUserSettingsRequest
 */
export type ListUserSettingsRequest = Message<"user.ListUserSettingsRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string section = 2;
   */
  section?: string;

  /**
   * @generated from field: optional string key = 3;
   */
  key?: string;
};

/**
 * Describes the message user.ListUserSettingsRequest.
 * Use `create(ListUserSettingsRequestSchema)` to create a new message.
 */
export const ListUserSettingsRequestSchema: GenMessage<ListUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 1);

/**
 * @generated from message user.ListUserSettingsResponse
 */
export type ListUserSettingsResponse = Message<"user.ListUserSettingsResponse"> & {
  /**
   * @generated from field: repeated common.UserSettingMessage data = 1;
   */
  data: UserSettingMessage[];
};

/**
 * Describes the message user.ListUserSettingsResponse.
 * Use `create(ListUserSettingsResponseSchema)` to create a new message.
 */
export const ListUserSettingsResponseSchema: GenMessage<ListUserSettingsResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 2);

/**
 * @generated from message user.CreateUserSettingRequest
 */
export type CreateUserSettingRequest = Message<"user.CreateUserSettingRequest"> & {
  /**
   * @generated from field: optional string section = 1;
   */
  section?: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: optional google.protobuf.Struct value = 3;
   */
  value?: JsonObject;
};

/**
 * Describes the message user.CreateUserSettingRequest.
 * Use `create(CreateUserSettingRequestSchema)` to create a new message.
 */
export const CreateUserSettingRequestSchema: GenMessage<CreateUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 3);

/**
 * @generated from message user.UpdateUserSettingRequest
 */
export type UpdateUserSettingRequest = Message<"user.UpdateUserSettingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string section = 2;
   */
  section?: string;

  /**
   * @generated from field: optional string key = 3;
   */
  key?: string;

  /**
   * @generated from field: optional google.protobuf.Struct value = 4;
   */
  value?: JsonObject;
};

/**
 * Describes the message user.UpdateUserSettingRequest.
 * Use `create(UpdateUserSettingRequestSchema)` to create a new message.
 */
export const UpdateUserSettingRequestSchema: GenMessage<UpdateUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 4);

/**
 * @generated from message user.DeleteUserSettingRequest
 */
export type DeleteUserSettingRequest = Message<"user.DeleteUserSettingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message user.DeleteUserSettingRequest.
 * Use `create(DeleteUserSettingRequestSchema)` to create a new message.
 */
export const DeleteUserSettingRequestSchema: GenMessage<DeleteUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 5);

/**
 * @generated from message user.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"user.ListSessionsRequest"> & {
  /**
   * @generated from field: optional common.Pagination pagination = 1;
   */
  pagination?: Pagination;
};

/**
 * Describes the message user.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 6);

/**
 * @generated from message user.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"user.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated common.SessionMessage data = 1;
   */
  data: SessionMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message user.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 7);

/**
 * @generated from message user.DeleteSessionRequest
 */
export type DeleteSessionRequest = Message<"user.DeleteSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message user.DeleteSessionRequest.
 * Use `create(DeleteSessionRequestSchema)` to create a new message.
 */
export const DeleteSessionRequestSchema: GenMessage<DeleteSessionRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 8);

/**
 * @generated from message user.ChangeEmailRequest
 */
export type ChangeEmailRequest = Message<"user.ChangeEmailRequest"> & {
  /**
   * @generated from field: string new_email = 1;
   */
  newEmail: string;
};

/**
 * Describes the message user.ChangeEmailRequest.
 * Use `create(ChangeEmailRequestSchema)` to create a new message.
 */
export const ChangeEmailRequestSchema: GenMessage<ChangeEmailRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 9);

/**
 * @generated from message user.VerifyEmailRequest
 */
export type VerifyEmailRequest = Message<"user.VerifyEmailRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message user.VerifyEmailRequest.
 * Use `create(VerifyEmailRequestSchema)` to create a new message.
 */
export const VerifyEmailRequestSchema: GenMessage<VerifyEmailRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 10);

/**
 * @generated from message user.UploadAvatarRequest
 */
export type UploadAvatarRequest = Message<"user.UploadAvatarRequest"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;
};

/**
 * Describes the message user.UploadAvatarRequest.
 * Use `create(UploadAvatarRequestSchema)` to create a new message.
 */
export const UploadAvatarRequestSchema: GenMessage<UploadAvatarRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 11);

/**
 * @generated from message user.UploadChartBackgroundRequest
 */
export type UploadChartBackgroundRequest = Message<"user.UploadChartBackgroundRequest"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;
};

/**
 * Describes the message user.UploadChartBackgroundRequest.
 * Use `create(UploadChartBackgroundRequestSchema)` to create a new message.
 */
export const UploadChartBackgroundRequestSchema: GenMessage<UploadChartBackgroundRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 12);

/**
 * @generated from message user.UploadChartBackgroundResponse
 */
export type UploadChartBackgroundResponse = Message<"user.UploadChartBackgroundResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message user.UploadChartBackgroundResponse.
 * Use `create(UploadChartBackgroundResponseSchema)` to create a new message.
 */
export const UploadChartBackgroundResponseSchema: GenMessage<UploadChartBackgroundResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 13);

/**
 * @generated from message user.GenerateTotpSecretResponse
 */
export type GenerateTotpSecretResponse = Message<"user.GenerateTotpSecretResponse"> & {
  /**
   * @generated from field: string secret = 1;
   */
  secret: string;

  /**
   * @generated from field: string otpauth_url = 2;
   */
  otpauthUrl: string;
};

/**
 * Describes the message user.GenerateTotpSecretResponse.
 * Use `create(GenerateTotpSecretResponseSchema)` to create a new message.
 */
export const GenerateTotpSecretResponseSchema: GenMessage<GenerateTotpSecretResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 14);

/**
 * @generated from message user.EnableTotpRequest
 */
export type EnableTotpRequest = Message<"user.EnableTotpRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message user.EnableTotpRequest.
 * Use `create(EnableTotpRequestSchema)` to create a new message.
 */
export const EnableTotpRequestSchema: GenMessage<EnableTotpRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 15);

/**
 * @generated from message user.CheckNicknameAvailableRequest
 */
export type CheckNicknameAvailableRequest = Message<"user.CheckNicknameAvailableRequest"> & {
  /**
   * @generated from field: string nickname = 1;
   */
  nickname: string;
};

/**
 * Describes the message user.CheckNicknameAvailableRequest.
 * Use `create(CheckNicknameAvailableRequestSchema)` to create a new message.
 */
export const CheckNicknameAvailableRequestSchema: GenMessage<CheckNicknameAvailableRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 16);

/**
 * @generated from message user.CheckNicknameAvailableResponse
 */
export type CheckNicknameAvailableResponse = Message<"user.CheckNicknameAvailableResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;
};

/**
 * Describes the message user.CheckNicknameAvailableResponse.
 * Use `create(CheckNicknameAvailableResponseSchema)` to create a new message.
 */
export const CheckNicknameAvailableResponseSchema: GenMessage<CheckNicknameAvailableResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 17);

/**
 * @generated from message user.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"user.DeleteAccountRequest"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message user.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 18);

/**
 * @generated from message user.RestoreAccountRequest
 */
export type RestoreAccountRequest = Message<"user.RestoreAccountRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message user.RestoreAccountRequest.
 * Use `create(RestoreAccountRequestSchema)` to create a new message.
 */
export const RestoreAccountRequestSchema: GenMessage<RestoreAccountRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 19);

/**
 * @generated from message user.StartKycResponse
 */
export type StartKycResponse = Message<"user.StartKycResponse"> & {
  /**
   * @generated from field: string form_url = 1;
   */
  formUrl: string;
};

/**
 * Describes the message user.StartKycResponse.
 * Use `create(StartKycResponseSchema)` to create a new message.
 */
export const StartKycResponseSchema: GenMessage<StartKycResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 20);

/**
 * @generated from message user.GetKycStatusResponse
 */
export type GetKycStatusResponse = Message<"user.GetKycStatusResponse"> & {
  /**
   * @generated from field: common.KycStatus status = 1;
   */
  status: KycStatus;

  /**
   * @generated from field: optional string verified_at = 2;
   */
  verifiedAt?: string;

  /**
   * @generated from field: optional string verification_id = 3;
   */
  verificationId?: string;
};

/**
 * Describes the message user.GetKycStatusResponse.
 * Use `create(GetKycStatusResponseSchema)` to create a new message.
 */
export const GetKycStatusResponseSchema: GenMessage<GetKycStatusResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 21);

/**
 * @generated from message user.GetKycEscalationStatusResponse
 */
export type GetKycEscalationStatusResponse = Message<"user.GetKycEscalationStatusResponse"> & {
  /**
   * @generated from field: bool action_required = 1;
   */
  actionRequired: boolean;

  /**
   * @generated from field: bool under_review = 2;
   */
  underReview: boolean;

  /**
   * @generated from field: bool finally_declined = 3;
   */
  finallyDeclined: boolean;

  /**
   * @generated from field: optional string form_name = 4;
   */
  formName?: string;

  /**
   * @generated from field: optional string check_description = 5;
   */
  checkDescription?: string;

  /**
   * @generated from field: bool escalation_approved = 6;
   */
  escalationApproved: boolean;
};

/**
 * Describes the message user.GetKycEscalationStatusResponse.
 * Use `create(GetKycEscalationStatusResponseSchema)` to create a new message.
 */
export const GetKycEscalationStatusResponseSchema: GenMessage<GetKycEscalationStatusResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 22);

/**
 * @generated from message user.VerifyIdentityCodeRequest
 */
export type VerifyIdentityCodeRequest = Message<"user.VerifyIdentityCodeRequest"> & {
  /**
   * @generated from field: string email_code = 1;
   */
  emailCode: string;

  /**
   * @generated from field: optional string totp_code = 2;
   */
  totpCode?: string;
};

/**
 * Describes the message user.VerifyIdentityCodeRequest.
 * Use `create(VerifyIdentityCodeRequestSchema)` to create a new message.
 */
export const VerifyIdentityCodeRequestSchema: GenMessage<VerifyIdentityCodeRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 23);

/**
 * @generated from message user.OnboardingStateResponse
 */
export type OnboardingStateResponse = Message<"user.OnboardingStateResponse"> & {
  /**
   * @generated from field: common.OnboardingStatus status = 1;
   */
  status: OnboardingStatus;

  /**
   * @generated from field: bool deposit_recovery_pending = 2;
   */
  depositRecoveryPending: boolean;

  /**
   * @generated from field: bool deposit_recovery_shown = 3;
   */
  depositRecoveryShown: boolean;

  /**
   * @generated from field: int32 action_delay_ms = 4;
   */
  actionDelayMs: number;

  /**
   * @generated from field: optional string bonus_promo_code = 5;
   */
  bonusPromoCode?: string;

  /**
   * @generated from field: int32 replay_count = 6;
   */
  replayCount: number;
};

/**
 * Describes the message user.OnboardingStateResponse.
 * Use `create(OnboardingStateResponseSchema)` to create a new message.
 */
export const OnboardingStateResponseSchema: GenMessage<OnboardingStateResponse> = /*@__PURE__*/
  messageDesc(file_user_user, 24);

/**
 * @generated from message user.UpdateOnboardingStateRequest
 */
export type UpdateOnboardingStateRequest = Message<"user.UpdateOnboardingStateRequest"> & {
  /**
   * @generated from field: optional common.OnboardingStatus status = 1;
   */
  status?: OnboardingStatus;

  /**
   * @generated from field: optional bool deposit_recovery_pending = 2;
   */
  depositRecoveryPending?: boolean;

  /**
   * @generated from field: optional bool deposit_recovery_shown = 3;
   */
  depositRecoveryShown?: boolean;
};

/**
 * Describes the message user.UpdateOnboardingStateRequest.
 * Use `create(UpdateOnboardingStateRequestSchema)` to create a new message.
 */
export const UpdateOnboardingStateRequestSchema: GenMessage<UpdateOnboardingStateRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 25);

/**
 * @generated from message user.RecordOnboardingEventRequest
 */
export type RecordOnboardingEventRequest = Message<"user.RecordOnboardingEventRequest"> & {
  /**
   * @generated from field: string event = 1;
   */
  event: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: optional string screen_id = 3;
   */
  screenId?: string;

  /**
   * @generated from field: optional int32 step_index = 4;
   */
  stepIndex?: number;

  /**
   * @generated from field: optional string method = 5;
   */
  method?: string;

  /**
   * @generated from field: string variant = 6;
   */
  variant: string;

  /**
   * @generated from field: optional string locale = 7;
   */
  locale?: string;

  /**
   * @generated from field: optional string device_type = 8;
   */
  deviceType?: string;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 9;
   */
  payload?: JsonObject;
};

/**
 * Describes the message user.RecordOnboardingEventRequest.
 * Use `create(RecordOnboardingEventRequestSchema)` to create a new message.
 */
export const RecordOnboardingEventRequestSchema: GenMessage<RecordOnboardingEventRequest> = /*@__PURE__*/
  messageDesc(file_user_user, 26);

/**
 * @generated from service user.UserRPCService
 */
export const UserRPCService: GenService<{
  /**
   * @generated from rpc user.UserRPCService.GetProfile
   */
  getProfile: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.UpdateProfile
   */
  updateProfile: {
    methodKind: "unary";
    input: typeof UpdateProfileRequestSchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.GetBalance
   */
  getBalance: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof AccountMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.ListSettings
   */
  listSettings: {
    methodKind: "unary";
    input: typeof ListUserSettingsRequestSchema;
    output: typeof ListUserSettingsResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.CreateSetting
   */
  createSetting: {
    methodKind: "unary";
    input: typeof CreateUserSettingRequestSchema;
    output: typeof UserSettingMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.UpdateSetting
   */
  updateSetting: {
    methodKind: "unary";
    input: typeof UpdateUserSettingRequestSchema;
    output: typeof UserSettingMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.DeleteSetting
   */
  deleteSetting: {
    methodKind: "unary";
    input: typeof DeleteUserSettingRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.DeleteSession
   */
  deleteSession: {
    methodKind: "unary";
    input: typeof DeleteSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.SendEmailVerification
   */
  sendEmailVerification: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.ChangeEmail
   */
  changeEmail: {
    methodKind: "unary";
    input: typeof ChangeEmailRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.VerifyEmail
   */
  verifyEmail: {
    methodKind: "unary";
    input: typeof VerifyEmailRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.UploadAvatar
   */
  uploadAvatar: {
    methodKind: "unary";
    input: typeof UploadAvatarRequestSchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.DeleteAvatar
   */
  deleteAvatar: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * Uploads a custom chart background image to the user's own S3 prefix and
   * returns its public URL — same validation as UploadAvatar (magic-bytes +
   * 5MB cap). Unlike UploadAvatar this does not write anywhere itself; the
   * caller persists the returned url into its own UserSetting value.
   *
   * @generated from rpc user.UserRPCService.UploadChartBackground
   */
  uploadChartBackground: {
    methodKind: "unary";
    input: typeof UploadChartBackgroundRequestSchema;
    output: typeof UploadChartBackgroundResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.GenerateTotpSecret
   */
  generateTotpSecret: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GenerateTotpSecretResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.EnableTotp
   */
  enableTotp: {
    methodKind: "unary";
    input: typeof EnableTotpRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.DisableTotp
   */
  disableTotp: {
    methodKind: "unary";
    input: typeof EnableTotpRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.CheckNicknameAvailable
   */
  checkNicknameAvailable: {
    methodKind: "unary";
    input: typeof CheckNicknameAvailableRequestSchema;
    output: typeof CheckNicknameAvailableResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.RestoreAccount
   */
  restoreAccount: {
    methodKind: "unary";
    input: typeof RestoreAccountRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.StartKyc
   */
  startKyc: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StartKycResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.GetKycStatus
   */
  getKycStatus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetKycStatusResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.VerifyIdentityCode
   */
  verifyIdentityCode: {
    methodKind: "unary";
    input: typeof VerifyIdentityCodeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.GetKycEscalationStatus
   */
  getKycEscalationStatus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetKycEscalationStatusResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.StartKycEscalationForm
   */
  startKycEscalationForm: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StartKycResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.GetOnboardingState
   */
  getOnboardingState: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof OnboardingStateResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.UpdateOnboardingState
   */
  updateOnboardingState: {
    methodKind: "unary";
    input: typeof UpdateOnboardingStateRequestSchema;
    output: typeof OnboardingStateResponseSchema;
  },
  /**
   * @generated from rpc user.UserRPCService.RecordOnboardingEvent
   */
  recordOnboardingEvent: {
    methodKind: "unary";
    input: typeof RecordOnboardingEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc user.UserRPCService.ReplayOnboarding
   */
  replayOnboarding: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof OnboardingStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_user, 0);

